import cn from 'classnames';
import { Accordion, AccordionGroup, Grid } from 'ht-styleguide';
import styles from '../plansPage.module.scss';

const Faq = ({ planName }: any) => {
  const PLAN_FAQ_ITEMS = [
    {
      id: 1,
      questionText: 'Do I have to use all of the services in the membership?',
      answerText: 'All of our services are strictly optional. Our principal objective is to secure your tech and simplify your life.',
    },
    {
      id: 2,
      questionText: 'How does the no-risk guarantee work?',
      answerText: `Applicable fees for the ${planName} Membership are billed upfront, along with any ancillary services that may have been purchased within it. If you are not satisfied with the plan in the first 30 days, we will refund the cost of your membership less any discounts you may have received on services.`,
    },
    {
      id: 3,
      questionText: 'How long is the plan? Does it renew automatically?',
      answerText: `Your ${planName} Membership is good for one full year, and it is conveniently set to renew automatically. Members may turn off the auto renewal by logging onto their password-protected member portal and changing their settings.`,
    },
    {
      id: 4,
      questionText: 'What is the Home Technology Checkup?',
      answerText:
        'The Home Technology Checkup is an annual, in-home visit where a HelloTech expert reviews your home’s technology systems. This comprehensive review includes your main computer, Internet connection, router, and WiFi. It results in an actionable report you can use to understand how your tech systems are working and make them work even better.',
    },
  ];

  return (
    <Grid.Fluid classes={cn('paddingY-huge', styles.faqContainer)}>
      <h3 className="n900 text-align-center">Frequently Asked Questions</h3>
      <Grid.Row>
        <Grid.Column sm={4} md={6} mdOffset={1} lg={6} lgOffset={3}>
          <AccordionGroup className="marginTop-small2">
            {PLAN_FAQ_ITEMS.map(f => (
              <Accordion key={f.id} title={f.questionText} withBottomBorder className={styles.item}>
                <div className={cn('p1 n900', styles.text)}>{f.answerText}</div>
              </Accordion>
            ))}
          </AccordionGroup>
        </Grid.Column>
      </Grid.Row>
    </Grid.Fluid>
  );
};

export default Faq;
